import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, NotifyState} from '@/types/store/states'
import {RawNotify} from '@/types/entity/RawNotify'
import Notify from '@/models/notify/Notify'
import $store from '@/store'
import {API} from '@/constants'


const store: Module<NotifyState, RootState> = {
  namespaced: true,
  state: {
    notifies: {}
  },
  getters: {
    getItem: state => (data: RawNotify) => {
      if (state.notifies[data.notify_id]) {
        state.notifies[data.notify_id].setData(data)
      } else {
        Vue.set(state.notifies, data.notify_id, new Notify(data))
      }
      return state.notifies[data.notify_id]
    },
    getItems: (state, getters) => (items: RawNotify[]) => {
      const result = [];
      for (const item of items) {
        const data = getters.getItem(item);
        result.push(data)
      }
      return result;
    }
  },
  mutations: {},
  actions: {
    async getList (context, data) {
      const response = await context.dispatch('apiRequest', {
        url: API.notify.getList,
        data,
        flag: 'silent'
      }, {root: true})
      return context.getters.getItems(response.items);
    },
    async markRead (context, ids) {
      const response = await context.dispatch('apiRequest', {
        url: API.notify.markRead,
        data: {ids},
        flag: 'silent'
      }, {root: true})
      return response;
    },
    async selfTest (context, value) {
      const response = await context.dispatch('apiRequest', {
        url: API.notify.selfTest,
        data: {value},
        flag: 'silent'
      }, {root: true})
      return response;
    }
  }
}

export default store